import { Fragment, useState } from 'react';
import { generalStyle } from 'helper/Style';
import Modal, { modalStyle } from 'component/part/Modal';

export type OperationTriggerProps = {
  onSubmit: () => Promise<boolean>;
  onConfirm?: () => boolean | Promise<boolean>;
  onOk?: () => void | Promise<void>;
  onCancel?: () => void;
  buttonText: string;
  confirmText: string;
  doneText: string;
  errorText: string;
  submitText: string;
  okText?: string;
  className?: string;
};

const OperationTrigger = (props: OperationTriggerProps) => {
  const [status, setStatus] = useState<'confirm' | 'done' | 'error' | null>(null);
  const modalText = status
    ? {
      confirm: props.confirmText,
      done: props.doneText,
      error: props.errorText,
    }[status]
    : '';

  const onConfirm = async () => {
    const confirmed = props?.onConfirm ? await props.onConfirm() : true;
    if (confirmed) {
      setStatus('confirm');
    }
  };

  const onSubmit = async () => {
    setStatus(null);
    const result = await props.onSubmit();
    setStatus(result ? 'done' : 'error');
  };

  const onOk = () => {
    setStatus(null);
    props.onOk
      ? props.onOk()
      : props.onCancel?.();
  };

  const onCancel = () => {
    setStatus(null);
    props.onCancel?.();
  };

  return <Fragment>
    <div css={generalStyle.formRow} className={props.className}>
      <button type='button' onClick={onConfirm} css={generalStyle.button()}>{props.buttonText}</button>
    </div>
    <Modal display={!!status} onHide={status === 'done' ? onOk : onCancel}>
      <div>{modalText}</div>
      <div css={modalStyle.buttonArea}>
        {status === 'confirm' ? (
          <Fragment>
            <button onClick={onSubmit} css={generalStyle.button()}>{props.submitText}</button>
            <button onClick={onCancel} css={generalStyle.button('warning')}>キャンセル</button>
          </Fragment>
        ) : (
          <button onClick={status === 'done' ? onOk : onCancel} css={generalStyle.button()}>
            {props.okText || 'OK'}
          </button>
        )}
      </div>
    </Modal>
  </Fragment>;
};

export default OperationTrigger;
